// Helpers
import { getOutlinedPositionIcon } from "@/Common/helpers/Positions/icons";

// Layouts
import PageLayer from "@/Layouts/views/PageLayer";

// Layer
import Layer from "@PayPlans/views/Layers/Departments/Advisors";

const POSITION = "Body Shop Estimator";

export default function Advisors() {
	const Icon = getOutlinedPositionIcon({ position: POSITION });
	return (
		<PageLayer title={"Body Shop Estimator Pay Plans"} icon={Icon}>
			<Layer position={POSITION} defaultSections={["default"]} />
		</PageLayer>
	);
}
